import axios from 'axios';
import { from } from 'rxjs';

export const updateFulfillmentPlanNote = (fulfillmentPlanId, note) => {
  const put = axios.put(`/fulfillmentplan/${fulfillmentPlanId}/note`, note);

  const put$ = from(put);
  return put$;
};

export const deleteFulfillmentPlan = (fulfillmentPlanId, checkSalesOrderItemsOnly = false) => {
  return axios.delete(`/fulfillmentplan/${fulfillmentPlanId}?checkSalesOrderItemsOnly=${checkSalesOrderItemsOnly}`);
};

export const unlinkFulfillmentPlan = (fulfillmentPlanId, salesOrderId) => {
  return axios.put('/fulfillmentplan/unlink', {
    fulfillmentPlanId,
    salesOrderId,
  });
};

export const updateFulfillmentPlansShipBy = (fulfillmentPlanIds, shipByDate) => {
  return axios.put('/fulfillmentplan/shipby', {
    fulfillmentPlanIds,
    shipByDate,
  });
};

export const updateFulfillmentPlansHoldUntil = (fulfillmentPlanIds, holdUntilDate) => {
  return axios.put('/fulfillmentplan/holduntil', {
    fulfillmentPlanIds,
    holdUntilDate,
  });
};

export const updateFulfillmentPlansIsGift = (fulfillmentPlanIds, isGift) => {
  return axios.post('/fulfillmentplan/isGift', { fulfillmentPlanIds, isGift });
};

export const updateFulfillmentPlansAssignedTo = (fulfillmentPlanIds, assignedToUserId) => {
  return axios.put('/fulfillmentplan/assignedto', {
    fulfillmentPlanIds,
    assignedToUserId,
  });
};

export const updateFulfillmentPlansDeliverBy = (fulfillmentPlanIds, deliverByDate) => {
  return axios.put('/fulfillmentplan/deliverby', {
    fulfillmentPlanIds,
    deliverByDate,
  });
};

/**
 * @typedef FulfillmentPlanAmountSummaryRequest
 * @param {string} fulfillmentPlanId - fulfillmentPlanId to update.
 * @param {decimal} shippingPaid - shippingPaid to update for fulfillmentPlanId.
 * @param {decimal} taxPaid - taxPaid to update for fulfillmentPlanId.
 * @param {decimal} totalPaid - totalPaid to update for fulfillmentPlanId.
 * @param {decimal} orderTotal - orderTotal to update for fulfillmentPlanId.
 */
/**
 * Request for updating the tags for a list of fulfillmentPlanIds.
 * @param {FulfillmentPlanAmountSummaryRequest} request
 * @returns {Promise<AxiosResponse<FulfillmentPlan[]>>}
 */
export const updateFulfillmentPlansAmountSummary = (request) => {
  return axios.put('/fulfillmentplan/amountsummary', request);
};

export const updateFulfillmentPlansPaidDate = (fulfillmentPlanIds, payDate) => {
  return axios.put('/fulfillmentplan/pay', { fulfillmentPlanIds, payDate });
};

export const updateFulfillmentPlanAddress = (request) => {
  return axios.put('/fulfillmentplan/shiptoandrecipient', request);
};

export const validateAndUpdateAddress = (request) => {
  return axios.put('/fulfillmentplan/shipto', request);
};

/**
 * @typedef ValidateAndUpdateAddressRequest
 * @param {Array} fulfillmentPlanIds - fulfillmentPlanId to update.
 * @param {object} shipTo - shipTo address to update.
 * @param {boolean} validateAddress - boolean describing if the address has been validated or not.
 */
/**
 * Request for validating and updating an address on the fulfillmentPlan.
 * @param {ValidateAndUpdateAddressRequest} request
 * @returns {Promise<AxiosResponse<FulfillmentPlan[]>>}
 */
export const validateAndUpdateAddressObservable = (request) => {
  const put = validateAndUpdateAddress(request);

  const put$ = from(put);
  return put$;
};

export const updateFulfillmentPlanRecipientTaxIdentifier = async (request) => {
  return axios.put('/fulfillmentplan/recipienttaxidentifier', request);
};

export const updateFulfillmentPlanRecipientTaxIdentifiers = async (request) => {
  return axios.put('/fulfillmentplan/recipienttaxidentifiers', request);
};
